module.exports = __webpack_public_path__ + "img/business_14.b8130b32.jpg";